import React from 'react';
import { Section as SectionView } from './Section';
import { JsonObject } from '../../definitions/JsonObject';
import { Section } from '../../app/consumer/header/notifications_new.view';

interface NotificationsPanelProps {
  content: JsonObject;
  correlationId: string;
  sections: Section[];
}

export default function NotificationsPanel({ content, correlationId, sections }: NotificationsPanelProps) {
  const newNotificationsCollection = (sections || []).map((section) => section.alerts || []).flat();
  const showNotificationsZeroState = newNotificationsCollection.length === 0;

  return (
    <div className="cw_panel_new cw_panel_notifications cw_panel_selected" id="cw_panel-notifications">
      {showNotificationsZeroState ? (
        <ZeroNotification content={content} />
      ) : (
        sections?.map((section, i) => <SectionView key={i} section={section} correlationId={correlationId} />)
      )}
    </div>
  );
}

export function ZeroNotification({ content }: { content: JsonObject }) {
  const message = content.noNotificationHeader;
  const subHeader = content.noNotificationSubheader;
  return (
    <div className="cw_empty_state_panel">
      <img alt="" className="cw_empty_state_tile" src="https://www.paypalobjects.com/nc/ui-web/zeronotifications.png" />
      <div className="cw_empty_state_subheader">{message}</div>
      <div className="cw_empty_state_description">{subHeader}</div>
    </div>
  );
}
